import { DrawerHeader } from 'design-system';
import type { ReactNode } from 'react';

type AskGXHeaderProps = {
  actions: ReactNode;
};

const AskGXHeader = ({ actions }: AskGXHeaderProps) => (
  <DrawerHeader className='min-h-14 gap-2 border-[#26272f] bg-[#0a0a0f] px-4 py-4'>
    <div className='flex min-w-0 flex-1 items-center'>
      <h2 className='truncate text-[13px] leading-none font-extrabold tracking-[0.04em] text-[#f3f2ed]'>
        GX Analyst
      </h2>
    </div>
    <div className='flex items-center gap-1'>{actions}</div>
  </DrawerHeader>
);

export default AskGXHeader;
